<template>
    <st-button-styled
        :color="color"
        :width="width"
        :size="size"
        :block="block"
        :disabled="disabled"
        @click="clickHandler"
    >
        <slot />
    </st-button-styled>
</template>
<script>
import styled, { css } from "vue-styled-components";

const props = {
    color: String,
    width: Number,
    block: Boolean,
    size: {
        type: String,
        default: () => "middle"
    }
};

const StButtonStyled = styled("button", props)`
    border-radius: 5px;
    display: inline-block;
    cursor: pointer;

    & + button {
        margin-left: 1rem;
    }

    ${props =>
        props.color
            ? props.theme.box[props.color]
            : css`
                  border: none;
              `}

    &:disabled {
        ${props => props.theme.box.disabled}
    }

    ${props => {
        const size = props.theme.size[props.size];
        const abs = (0.298 * size).toFixed(1);

        return css`
            height: ${size}rem;
            font-size: ${abs}rem;
        `;
    }}

    ${props =>
        props.block
            ? "width: 100%;"
            : props.width
            ? css`
                  width: ${props.width}rem;
              `
            : css`
                  padding: 0 2.4rem;
              `}
`;

export default {
    name: "StButton",
    props: { link: Boolean, path: String, target: String, disabled: Boolean, ...props },
    methods: {
        clickHandler(ev) {
            ev.preventDefault();

            if (this.link) {
                this.go();
                return;
            }

            this.$emit("click", ev);
        },

        go() {
            const link = document.createElement("a");
            link.href = this.path;
            link.target = "_blank";

            link.click();
            link.remove();
        }
    },
    components: {
        StButtonStyled
    }
};
</script>
